import React from 'react';
import defaulHeader from '../../assets/header-background.jpg';

const Header = ({blog, baseURL}) => {
  return (
    <section class="header-apa-psre">
      <img src={blog.picture ? baseURL+'/'+blog.picture : defaulHeader} alt='blogPicture' style={{width: '100%', height: '200px', objectFit:  'cover'}}/>
    </section>
  )
}

export default Header